import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, BillItemsByChargeEntryCodeController, BillItemsByChargeEntryCodeRequest, X_BillItemsController, x_BillDetailsRequest, BillDetailsInfoController, X_BillReceiptsController, X_BillHeaderController } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'refundbill',
  templateUrl: './refundbill.component.html',
  styleUrls: ['./refundbill.component.scss']
})

export class RefundbillPVComponent implements OnInit {

    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;

    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;

    public Date: Date;
    public PatientId: string;
    public ChargeEntry: any;
    public PatientName: string;
    public PayeeName: string;
    public Toatalbill: number;
    public PaidBill: number;

    public Owner: string;
    public Gender: string;
    public Age: string;
    public BillDate: string;
    public BillNo: string;
    public Branch: string;
    public GrandTotal: string;
    public Discount: string;
    public Tax: string;
  public Net: string; 
  public Due: string; 
  public ReferralData: string;
  public RefundData: string;

  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = this.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadBillItems();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

    CurrentX_BillItemsController: X_BillItemsController[];
    //FollicularScanEndInfo: FollicularScanDetailController;
    //BillHeader: X_BillHeaderController[];
    CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController;
  BillData2: X_BillItemsController;

    LoadBillItems() {
        //alert("ScansData")
        this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
        this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetX_BillItemsController();
    }

    GetX_BillItemsController() {
        //this.StartRefreshing();

        this.CurrentX_BillItemsRequest.ChargeEntry = this.ChargeEntry;
        // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
        this.CurrentX_BillItemsRequest.ConditionalOperator = 5;
        //this.Cu
        //alert(this.FormattedCode);

        this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

                    this.BillData = this.ApiResData.Result;
                    this.CurrentX_BillItemsController = this.BillData.Items;
                  this.BillData2 = this.CurrentX_BillItemsController[1];
                    // this.CurrentX_BillHeaderController[0].PatientName;
                    //alert(this.CurrentX_BillHeaderController);
                    //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.LoadBillReceipts();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentX_BillReceiptsController: X_BillReceiptsController[];

    CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

    BillDataReceipt: BillDetailsInfoController;

    LoadBillReceipts() {
        //alert("ScansData")
        this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
        this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetX_BillReceiptsController();
    }

    GetX_BillReceiptsController() {
        //this.StartRefreshing();

        this.CurrentX_BillReceiptsRequest.ChargeEntry = this.ChargeEntry;
        // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
        this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;
        //this.Cu
        //alert(this.FormattedCode);

        this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

                    this.BillDataReceipt = this.ApiResData.Result;
                    this.CurrentX_BillReceiptsController = this.BillDataReceipt.Receipts;
                    this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
                    this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
                    this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
                    this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;



                    // this.CurrentX_BillHeaderController[0].PatientName;
                    //alert(this.CurrentX_BillHeaderController);
                    //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.LoadBills();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentBillItemsByChargeEntryCodeController: BillItemsByChargeEntryCodeController[];
    CurrentBillItemsByChargeEntryCodeRequest: BillItemsByChargeEntryCodeRequest;



    LoadBills() {
        this.CurrentBillItemsByChargeEntryCodeRequest = new BillItemsByChargeEntryCodeRequest();

        //alert('Checking Forma ' + this.FormattedCode);



        this.CurrentBillItemsByChargeEntryCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentBillItemsByChargeEntryCodeRequest.ChargeEntryCode = 10074;
        this.CurrentBillItemsByChargeEntryCodeRequest.ConditionalOperator = 10;
        this.GetBillItemsByChargeEntryCodeController();
    }
    GetBillItemsByChargeEntryCodeController() {
        this.StartRefreshing();


        this.actorservice.GetBillItemsByChargeEntryCodeController(this.CurrentBillItemsByChargeEntryCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentBillItemsByChargeEntryCodeController = this.ApiResData.Result;
                    //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.printService.onDataReady()
                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(private router: Router,
        private actorservice: ActorService,
        private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
        private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

        public printService: PrintService) {


    }


    ngOnInit() {

        this.Date = new Date();
      this.LoadBillHeader();
        this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
        this.PatientId = this.route.snapshot.paramMap.get('PatientId');

        this.Owner = this.route.snapshot.paramMap.get('Owner');
        this.Gender = this.route.snapshot.paramMap.get('Gender');
        this.Age = this.route.snapshot.paramMap.get('Age');
        this.BillDate = this.route.snapshot.paramMap.get('BillDate');
        this.BillNo = this.route.snapshot.paramMap.get('BillNo');
        this.Branch = this.route.snapshot.paramMap.get('Branch');
        this.GrandTotal = this.route.snapshot.paramMap.get('GrandTotal');
        this.Discount = this.route.snapshot.paramMap.get('Discount');
        this.Tax = this.route.snapshot.paramMap.get('Tax');
        this.Net = this.route.snapshot.paramMap.get('Net');
      this.Due = this.route.snapshot.paramMap.get('Due'); 
      this.ReferralData = this.route.snapshot.paramMap.get('ReferralData');
      this.RefundData = this.route.snapshot.paramMap.get('RefundData');
    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

}








